<template>
  <div class="about">
    <Header/>
    <div class="foto_news">
      <img class="imgs" v-bind:src="imagem">
    </div>
    <div class="body">
      <div class="sobre" v-for="not in noticias">
        <h4 v-html="not.titulo"> </h4><br>
        <div class="news" v-html="not.texto">
        </div>
        <div> <b>Fonte: </b> <span v-html="not.referencia"> </span> </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default{
  components:{
    Header,
    Footer
  },
  data (){
    return{
      id: 0,
      noticias:[],
      imagem:''
    }
  },
  mounted (){
    this.getNews()
  },
  created() {
    this.id = this.$route.params.id;
  },
  methods: {
    getNews(){
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
        }
      };
      let post = {
        id:this.id
      }
      this.axios
        .post('https://cursinhosapiencia.com.br/noticiaId.php', post, axiosConfig)
        .then(response => {
          this.imagem = response.data[0].imagem
          this.noticias = response.data
        })
    },
    navigate() {
      router.go(-1);
    }
  }
}
</script>

<style>
@import "../assets/style_padrao.css";

  #ast{
    color:red;
  }
  h1{
    text-align: center;
  }
  h2{
    text-align: left;
  }
  #msg{
    text-align: center;
  }
  .news{
    text-align: justify!important;
  }
  .imgs{
    width:50%;
  }
  .foto_news{
    padding-top:5%;
    display: flex;
    justify-content: center;
  }
</style>
